import { render, staticRenderFns } from "./SupportedCountries.vue?vue&type=template&id=02c898ae&scoped=true&"
import script from "./SupportedCountries.vue?vue&type=script&lang=ts&"
export * from "./SupportedCountries.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c898ae",
  null
  
)

export default component.exports